import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isDownloadAward: window.pageInfo['award']['download']
    };
  },
  computed: {
    downloadLink() {
      let link =
        window.location.origin +
        window.location.pathname +
        'index/download' +
        window.location.search;
      return window.globalGetGotoLink({ link });
    },
    ...mapGetters([
      'isLogin',
      'downloadHasGift',
      'letter',
      'roleId',
      'location'
    ])
  },
  methods: {
    downloadFn() {
      // 如果沒有發獎，就直接下载
      if (!this.isDownloadAward) {
        this.doDownload('', true);
        return;
      }

      // 如果還沒進入遊戲，就提示要先進遊戲
      if (!(this.isLogin && this.roleId)) {
        this.doDownload(this.letter.h5_download_login, true);
        return;
      }

      // 如果已經領過了，就提示已領
      if (this.downloadHasGift) {
        this.doDownload(this.letter.h5_download_repeat_get, true);
        return;
      }

      this.doDownload('', true);
      this.$store
        .dispatch('get_award', { giftType: 'download' })
        .then((res) => {
          // 如果领奖失败
          if (res.result == '0') {
            // 兼容一下161遊戲的旧接口
            this.doDownload(this.letter.h5_get_gift_fault, false);
            return;
          }
          this.doDownload(this.letter.h5_download_succ, false, true);
          this.$store.dispatch('get_award_state');

          try {
            globalConfig.statistics('download_gift');
          } catch (e) {}
        });
    },
    doDownload(text, isDown, judgeType) {
      if (isDown) {
        window.open(this.downloadLink, '_blank');
      }

      if (text) {
        this.$store.commit('updateCommonTips', text);
      }
    }
  }
};
